import { createI18n } from 'vue-i18n';

const savedLocale = localStorage.getItem('locale');

const i18n = createI18n({
  legacy: false,
  locale: savedLocale || 'en',
  fallbackLocale: 'en',
  messages: {
    en: require('/src/locales/en.json'),
    hr: require('/src/locales/hr.json'),
    de: require('/src/locales/de.json')
  }
});

export default i18n;
